import { interpolate, useAnimatedStyle } from 'react-native-reanimated';

import { useFantasyFullScreenPagerTransition } from '../FantasyFullScreenPagerTransitionProvider';

/**
 * Hook that returns the animated style that scales each item inside the circular pager carousel tab bar
 * It scales up the item when the pager "mounts" (uses `sheetMountAnimationProgress`)
 */
export const useScaleCarouselItemMountAnimation = () => {
    const { sheetMountAnimationProgress } = useFantasyFullScreenPagerTransition();

    return useAnimatedStyle(() => {
        return {
            transform: [
                {
                    scale: interpolate(sheetMountAnimationProgress.value, [-1, -0.5, 0], [0.5, 1, 1]),
                },
            ],
        };
    });
};
